export default "__VITE_ASSET__29e15454__"